import React from 'react';
import Icon from '../../../components/AppIcon';
import ContractorTableRow from './ContractorTableRow';

const ContractorTable = ({ contractors, onContractorClick, sortField, sortDirection, onSort }) => {
  const handleSort = (field) => {
    if (sortField === field) {
      onSort(field, sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      onSort(field, 'asc');
    }
  };

  if (contractors?.length === 0) {
    return (
      <div className="bg-card rounded-xl p-8 md:p-12 text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
          <Icon name="HardHat" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">No contractors found</h3>
        <p className="text-sm text-muted-foreground">Try adjusting your filters or add a new contractor to get started.</p>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-xl shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="border-b border-border">
            <tr style={{ background: 'linear-gradient(135deg, #1B3A5C 0%, #2D5580 100%)' }}>
              <th className="px-4 md:px-6 py-3 text-left">
                <button 
                  onClick={() => handleSort('name')}
                  className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white/90 hover:text-white transition-colors"
                >
                  Contractor
                  <Icon name={sortField === 'name' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} className="text-white/70" />
                </button>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-semibold uppercase tracking-wider text-white/90">Specialty</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-semibold uppercase tracking-wider text-white/90">Availability</span>
              </th>
              <th className="px-4 md:px-6 py-3 text-left hidden lg:table-cell">
                <button 
                  onClick={() => handleSort('rating')}
                  className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white/90 hover:text-white transition-colors"
                >
                  Rating
                  <Icon name={sortField === 'rating' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} className="text-white/70" />
                </button>
              </th>
              <th className="px-4 md:px-6 py-3 text-left hidden lg:table-cell">
                <button 
                  onClick={() => handleSort('totalProjects')}
                  className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-white/90 hover:text-white transition-colors"
                >
                  Projects
                  <Icon name={sortField === 'totalProjects' ? (sortDirection === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} className="text-white/70" />
                </button>
              </th>
              <th className="px-4 md:px-6 py-3 text-left">
                <span className="text-xs font-semibold uppercase tracking-wider text-white/90">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {contractors?.map((contractor) => (
              <ContractorTableRow
                key={contractor?.id}
                contractor={contractor}
                onClick={() => onContractorClick(contractor)}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContractorTable;